import { configureStore } from '@reduxjs/toolkit';
import MenuSlice from './slices/MenuSlice';

export const store = configureStore({
	reducer: {
		MenuSlice
	}
});
